module.exports = __webpack_public_path__ + "media/background_video.c984d549.mp4";